import * as React from 'react';
import { useDispatch } from 'react-redux';

import { FilterSingleChoose } from '../../../../components/FilterSingleChoose';
import { EDealTypes } from '../../../../constants/searchRealtors';
import { setDealType } from '../../../../actions/searchRealtors';
import { useDealType } from '../../../../hooks/selectors/searchRealtors';

const DEAL_TYPE_ITEMS = new Map([
  [EDealTypes.Any, 'Любая сделка'],
  [EDealTypes.Rent, 'Аренда'],
  [EDealTypes.BuyOrSale, 'Покупка и продажа'],
]);

export const DealTypeContainer: React.FC = () => {
  const dispatch = useDispatch();
  const dealType = useDealType();

  const handleSetDealType = React.useCallback(
    (selectedDealType: EDealTypes) => {
      dispatch(setDealType(selectedDealType));
    },
    [dispatch],
  );

  return (
    <FilterSingleChoose
      label="Тип сделки"
      items={DEAL_TYPE_ITEMS}
      onSelectItem={handleSetDealType}
      selectedItemKey={dealType}
    />
  );
};

DealTypeContainer.displayName = 'DealTypeContainer';
